export const settingLeaveDay = [
  {
    id_leave_time: 1,
    year: 2024,
    start_date: "01/01/2024",
    end_date: "31/12/2024",
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
    status: "active",
  },
  {
    id_leave_time: 1,
    year: 2024,
    start_date: "01/01/2024",
    end_date: "31/12/2024",
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
    status: "pending",
  },
];

export const mockDataSettingLeaveDayDetail = [
  {
    id_leave_time: 1,
    first_name: "นางมาริสา",
    last_name: "มากดีดก",
    nickname: "-",
    employee_no: "1234567833",
    position: "เจ้าหน้าที่ HR",
    department: "HR 1.1.1.1.1 (กลุ่มบริหารงานบุคคล)",
    work_experience: "3",
    user_update: "นางมาริสา มากดีดก",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_time: 2,
    first_name: "นางมาริสา",
    last_name: "มากดีดก",
    nickname: "-",
    employee_no: "1234567833",
    position: "เจ้าหน้าที่ HR",
    department: "HR 1.1.1.1.1 (กลุ่มบริหารงานบุคคล)",
    work_experience: "3",
    user_update: "นางมาริสา มากดีดก",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_time: 3,
    first_name: "นางมาริสา",
    last_name: "มากดีดก",
    nickname: "-",
    employee_no: "1234567833",
    position: "เจ้าหน้าที่ HR",
    department: "HR 1.1.1.1.1 (กลุ่มบริหารงานบุคคล)",
    work_experience: "3",
    user_update: "นางมาริสา มากดีดก",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_time: 4,
    first_name: "นางมาริสา",
    last_name: "มากดีดก",
    nickname: "-",
    employee_no: "1234567833",
    position: "เจ้าหน้าที่ HR",
    department: "HR 1.1.1.1.1 (กลุ่มบริหารงานบุคคล)",
    work_experience: "3",
    user_update: "นางมาริสา มากดีดก",
    last_update: "31/12/2024, 15:24",
  },
];

export const mockLeaveTypeHoliday = [
  {
    id_leave_type: 1,
    leave_type_name: "ลาป่วย",
    holiday_amount: 20,
    holiday_used: 10,
  },
  {
    id_leave_type: 2,
    leave_type_name: "ลากิจ",
    holiday_amount: 12,
    holiday_used: 2,
  },
  {
    id_leave_type: 3,
    leave_type_name: "ลาคลอดบุตร",
    holiday_amount: 97,
    holiday_used: 30,
  },
  {
    id_leave_type: 4,
    leave_type_name: "ลาพักผ่อนประจำปี",
    holiday_amount: 14,
    holiday_used: 5,
  },
  {
    id_leave_type: 5,
    leave_type_name: "ลาอุปสมบท",
    holiday_amount: 0,
    holiday_used: 0,
  },
];

export const mockLeaveType = [
  {
    id_leave_type: 1,
    leave_type_name: "ลาป่วย",
    status: 1,
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_type: 2,
    leave_type_name: "ลากิจ",
    status: 1,
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_type: 3,
    leave_type_name: "ลาคลอดบุตร",
    status: 0,
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_type: 4,
    leave_type_name: "ลาพักผ่อนประจำปี",
    status: 0,
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
  },
  {
    id_leave_type: 5,
    leave_type_name: "ลาอุปสมบท",
    status: 1,
    user_update: "mock user 1",
    last_update: "31/12/2024, 15:24",
  },
];

export const mockLoginHistory = [
  {
    id: 1,
    first_name: "นายสุเมธี",
    last_name: "ล่ำซำ",
    nickname: "-",
    type: "ออกจากระบบ",
    date: "02/06/2567",
    time: "16:45:30",
  },
  {
    id: 2,
    first_name: "นายสุเมธี",
    last_name: "ล่ำซำ",
    nickname: "-",
    type: "เข้าสู่ระบบ",
    date: "02/06/2567",
    time: "08:15:22",
  },
];

export const mockTimeRecord = [
  {
    id: 1,
    date: "02/06/2567",
    check_in: "08:45:22",
    check_out: "16:15:22",
  },
  {
    id: 2,
    date: "02/06/2567",
    check_in: "09:45:22",
    check_out: "16:25:22",
  },
  {
    id: 3,
    date: "02/06/2567",
    check_in: "10:45:22",
    check_out: "16:43:22",
  },
  {
    id: 4,
    date: "02/06/2567",
    check_in: "11:45:22",
    check_out: "16:34:22",
  },
];

export const mockRankTimeRecord = [
  {
    id: 1,
    profile: "",
    employee_name: "นางมาริสา มากดีดก",
    nickname: "-",
    employee_no: "-",
    position: "เจ้าหน้าที่ HR",
    department: "กลุ่มบริหารงานบุคคล",
    percent: 100,
  },
  {
    id: 2,
    profile: "",
    employee_name: "นายสมพงศ์  สุขสม",
    nickname: "-",
    employee_no: "-",
    position: "เจ้าหน้าที่ HR",
    department: "แผนกบริหารงานบุคคล",
    percent: 95,
  },
  {
    id: 3,
    profile: "",
    employee_name: "นายอาทิตย์ รุ่งเรือง",
    nickname: "-",
    employee_no: "-",
    position: "เจ้าหน้าที่ HR",
    department: "งานบริหารงานบุคคล",
    percent: 92,
  },
  {
    id: 4,
    profile: "",
    employee_name: "นางสาวสุรีย์ พิพัฒน์พงศ์",
    nickname: "-",
    employee_no: "-",
    position: "เจ้าหน้าที่ HR",
    department: "กองบริหารงานบุคคล",
    percent: 90,
  },
  {
    id: 5,
    profile: "",
    employee_name: "kak",
    nickname: "-",
    employee_no: "-",
    position: "dev",
    department: "it",
    percent: 50,
  },
];

export const mockDataCurrency = [
  {
    currency_id: 1,
    currency_name: "THB",
  },
  {
    currency_id: 2,
    currency_name: "USD",
  }
];
